<template>
  <div></div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {});
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
